<template>
  <!-- データ依存のタグ -->
  <Component
    :is="tag"
    v-bind="$props"
    class="jps-tag-span"
    :class="[
      `page-${serviceTypeValue}`,
      !notag && [
        `jps-tag jps-tag-${styledClassSuffix}`, {
          'jps-tag-ricon': withDelete,
          'styled-primary': styled === 'primary' || type === 'CORE' || type === 'WORD',
          'styled-secondary': styled === 'secondary',
          'styled-tertiary': styled === 'tertiary',
        }
      ]
    ]"
  >
    <slot v-bind="{ tag: tagValue, label: label }">
      <span
        v-if="type === 'COLOR'"
        class="color-circle"
        :style="tagStyle()"
      ></span>
      {{ ls(label) }}
      <BaseIcon
        v-if="withDelete"
        class="is-size-6 jps-icon-button"
        name="mdi/close-circle"
        alt="delete tag"
        @click="emits('delete')"
      >
      </BaseIcon
    ></slot>
  </Component>
</template>

<script lang="ts" setup>
const { ls } = useI18n()
const dataStore = useDataStore()

interface Props {
  id?: string
  tag?: string
  tagField?: TagField
  notag?: boolean
  withDelete?: boolean
  serviceType?: 'hina' | 'jps'
  styled?: 'primary' | 'secondary' | 'tertiary' | 'none'
}
const props = withDefaults(defineProps<Props>(), {
  tag: 'span',
})

const emits = defineEmits(['delete'])

const styledClassSuffix = computed(() => type.value.toLowerCase())

const type = computed(() => {
  if (!idValue.value) return 'WORD'
  switch (idValue.value.split('-')[0]) {
    case 'o':
      return 'CORE'
    case 'w':
      return 'WORD'
    case 'c':
      return 'COLOR'
    case 't':
      return 'TIME'
    case 'l':
      return 'LOCATION'
  }
})

const tagStyle = () => {
  if (type.value === 'COLOR') {
    const hex = idValue.value.substring(2)
    const color = chooseTextColor(hex)
    return { background: '#' + hex, color }
  }
}

const tagValue = computed(() => {
  return dataStore.tag(props.id)
})

const label = computed(() => {
  if (props.tagField) return props.tagField.label
  else if (tagValue.value) return tagValue.value.label
  else return {}
})

const idValue = computed(() => {
  return props.id || props.tagField.id
})

const { serviceType } = useServiceType()
const serviceTypeValue = props.serviceType || serviceType
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.page-jps {
  --primary-background-color: #{$jps-gray-800};
  --primary-border-color: #{$jps-gray-800};
  --primary-text-color: #{$white};
  --primary-hover-text-color: #{$white-hover};

  --secondary-background-color: #{$jps-gray-800};
  --secondary-border-color: #{$jps-gray-800};
  --secondary-text-color: #{$white};
  --secondary-hover-text-color: #{$white-hover};

  --tertiary-background-color: #{$jps-sub-red};
  --tertiary-border-color: #{$jps-sub-red};
  --tertiary-text-color: #{$white};
  --tertiary-hover-text-color: #{$white-hover};
}

.page-hina {
  --primary-background-color: #{$hina-background-green};
  --primary-border-color: #{$hina-accent-green};
  --primary-text-color: #{$black};
  --primary-hover-text-color: #{$white-hover};

  --secondary-background-color: #{$hina-background-cream};
  --secondary-border-color: #{$hina-accent-yellow};
  --secondary-text-color: #{$black};
  --secondary-hover-text-color: #{$white-hover};

  --tertiary-background-color: #{$hina-accent-lime};
  --tertiary-border-color: #{$hina-accent-lime};
  --tertiary-text-color: #{$black};
  --tertiary-hover-text-color: #{$white-hover};
}

.jps-tag-span {

  &.styled-primary {
    border: 1px solid var(--primary-border-color);
    @include tag-color(
      var(--primary-background-color),
      var(--primary-border-color),
      var(--primary-text-color),
      var(--primary-hover-text-color)
    );
  }

  &.styled-secondary {
    border: 1px solid var(--secondary-border-color);
    @include tag-color(
      var(--secondary-background-color),
      var(--secondary-border-color),
      var(--secondary-text-color),
      var(--secondary-hover-text-color)
    );
  }

  &.styled-tertiary {
    border: 1px solid var(--tertiary-border-color);
    @include tag-color(
      var(--tertiary-background-color),
      var(--tertiary-border-color),
      var(--tertiary-text-color),
      var(--tertiary-hover-text-color)
    );
  }
}
</style>
